module.exports = __webpack_public_path__ + "static/sello_v_ring-147aabc8a1e1ac4b82c1c3f2da884382.png";